import angular from "angular";

import Assert from "tbAssert";

const mLogSvc = new WeakMap();

const mChangeFilterFn = new WeakMap();
const mFilterEnabled = new WeakMap();
const mFilter = new WeakMap();

class SearchFilterConfig {
    constructor($log, changeFilterFn) {
        Assert.StrictAssert($log != null, "Assertion Failure: Missing Log Service Dependency");
        Assert.StrictAssert(changeFilterFn != null, "Assertion Failure: Missing Change Filter Callback Functon");

        mLogSvc.set(this, $log);

        mChangeFilterFn.set(this, changeFilterFn);
        mFilterEnabled.set(this, false);
        mFilter.set(this, null);
    }

    _getCurrentFilter() {
        return (mFilterEnabled.get(this) === true) ? (mFilter.get(this)) : null;
    }

    get isEnabled() {
        return mFilterEnabled.get(this);
    }

    set isEnabled(enableFilter) {
        if ((typeof enableFilter) !== "boolean") {
            throw new TypeError("SearchFilterConfig Enabled Can Only Be Set To Boolean Values");
        }

        let currentFilterEnabledVal = mFilterEnabled.get(this);

        if (mFilter.get(this) != null) {
            mFilterEnabled.set(this, enableFilter);
            mLogSvc.get(this).debug(`SearchFilterConfig isEnabledSetter: ${enableFilter ? "Enabling Filter" : "Disabling Filter"}`);
        }
        else {
            mFilterEnabled.set(this, false);
            mLogSvc.get(this).debug("SearchFilterConfig isEnabledSetter: Disabling Filter Because Current Filter Is Null");
        }

        if (currentFilterEnabledVal !== mFilterEnabled.get(this)) {
            mLogSvc.get(this).debug("SearchFilterConfig isEnabledSetter: Calling Change Filter");
            mChangeFilterFn.get(this)(this.currentFilter);
        }
    }

    get canEnable() {
        return (mFilter.get(this) != null);
    }

    get currentFilter() {
        return this._getCurrentFilter();
    }

    set currentFilter(newFilter) {
        mLogSvc.get(this).debug("SearchFilterConfig currentFilterSetter: Enter");

        if (newFilter == null) {
            mLogSvc.get(this).debug("SearchFilterConfig currentFilterSetter: Setting Current Filter to null and disabling it.");
            mFilter.set(this, null);
            mFilterEnabled.set(this, false);
        }
        else {
            mLogSvc.get(this).debug("SearchFilterConfig currentFilterSetter: Setting Current Filter to a non-null value and enabling it.");
            mFilter.set(this, newFilter);
            mFilterEnabled.set(this, true);
        }

        let updatedFilterVal = this._getCurrentFilter();
        mLogSvc.get(this).debug("SearchFilterConfig currentFilterSetter: Calling Change Filter.");
        mChangeFilterFn.get(this)(updatedFilterVal);
    }

    toString() {
        return `SearchFilterConfig/Enabled: ${this.isEnabled ? "true" : "false"}/FilterSet: ${(this.currentFilter != null) ? "Yes" : "No"}/`;
    }

    static Create($log) {
        return ((changeFilterFn) => new SearchFilterConfig($log, changeFilterFn));
    }
}

SearchFilterConfig.Create.$inject = [ "$log" ];

export default angular
    .module("trackerbase-app.views.tracking-event-search.search-filter-config",[])
    .factory("SearchFilterConfig", SearchFilterConfig.Create)
    .name;



//////////////////
// WEBPACK FOOTER
// ./src/views/tracking-event-search/SearchFilterConfig.js
// module id = WRCQ
// module chunks = 1